import React from 'react';
import './App.css';
import {Route, Routes, Navigate} from "react-router-dom";
import HomePage from "./pages/HomePage";
import SigninPage from "./pages/SigninPage";
import {UnprotectedLayout} from "./components/UnprotectedLayout";
import {ProtectedLayout} from "./components/ProtectedLayout";
import {SuperAdminLayout} from "./components/SuperAdminLayout";
import {AuthProvider} from "./hooks/useAuth";
import ProfilePage from "./pages/ProfilePage";
import SignupPage from "./pages/SignupPage";
import ForgotPage from "./pages/ForgotPage";
import {Provider} from "react-redux";
import {store} from "./store";
import { ConfigProvider } from 'antd';
import OrganisationPage from "./pages/OrganisationPage";
import EventsPage from "./pages/EventsPage";
import EventDetailPage from "./pages/EventDetailPage";
import GalleryDetailPage from "./pages/GalleryDetailPage";
import PasswordResetPage from "./pages/PasswordResetPage";
import PasswordSetPage from "./pages/PasswordSetPage";
import EventPage from "./pages/EventPage";
import {IntlProvider} from "react-intl";
import localeEn from "./locale/en";

// Admin pages
import AdminDashboardPage from "./pages/admin/AdminDashboardPage";
import AdminOrganisationsPage from "./pages/admin/AdminOrganisationsPage";
import AdminUsersPage from "./pages/admin/AdminUsersPage";
import AdminEventsPage from "./pages/admin/AdminEventsPage";
import AdminGalleriesPage from "./pages/admin/AdminGalleriesPage";
import AdminSettingsPage from "./pages/admin/AdminSettingsPage";
import AdminFeaturesPage from "./pages/admin/AdminFeaturesPage";
import AdminOrganisationEventsPage from "./pages/admin/AdminOrganisationEventsPage";
import AdminEventGalleriesPage from "./pages/admin/AdminEventGalleriesPage";
import AdminOrganisationDetailPage from "./pages/admin/AdminOrganisationDetailPage";
import AdminEventDetailPage from "./pages/admin/AdminEventDetailPage";
import AdminGalleryDetailPage from "./pages/admin/AdminGalleryDetailPage";
import AdminSystemSettingsPage from "./pages/admin/AdminSystemSettingsPage";

function App() {
  return (
      <ConfigProvider
          theme={{
              token: {
                  // Seed Token
                  colorPrimary: '#2d5b85',
                  colorTextBase: '#000000',
                  fontSize: 18,
                  colorLink: 'rgb(45, 91, 133)',
                  borderRadius: 2,
                  colorBgContainer: '#ffffff',

                  // Alias Token
              },
          }}
      >
          <Provider store={store}>
              <IntlProvider
                  messages={localeEn.messages}
                  locale={localeEn.code}
              >
                  <AuthProvider>
                      <Routes>
                          <Route element={<UnprotectedLayout />}>
                              <Route path="/" element={<HomePage />} />
                              <Route path="/:eventHash" element={<HomePage />} />
                              <Route path="/event" element={<EventPage />} />
                              <Route path="/event/:eventHash" element={<EventPage />} />
                              <Route path="/sign-in" element={<SigninPage />} />
                              <Route path="/forgot" element={<ForgotPage />} />
                              <Route path="/sign-up" element={<SignupPage />} />
                              <Route path="/password-reset/:resetToken" element={<PasswordResetPage />} />
                              <Route path="/password-set/:resetToken" element={<PasswordSetPage />} />
                          </Route>

                          <Route path="/dashboard" element={<ProtectedLayout />}>
                              {/* Make EventsPage the default page instead of DashboardPage */}
                              <Route path="" element={<EventsPage />} />
                              <Route path="profile" element={<ProfilePage />} />
                              <Route path="organisation" element={<OrganisationPage />} />
                              <Route path="events" element={<EventsPage />} />
                              <Route path="events/:eventId" element={<EventDetailPage />} />
                              <Route path="events/:eventId/galleries/:galleryId" element={<GalleryDetailPage />} />
                              {/* Add redirect for administration */}
                              <Route path="administration" element={<Navigate to="/admin/dashboard" replace />} />
                          </Route>
                          
                          {/* Super Admin Routes */}
                          <Route path="/admin" element={<SuperAdminLayout />}>
                              <Route path="" element={<AdminDashboardPage />} />
                              <Route path="dashboard" element={<AdminDashboardPage />} />
                              <Route path="organisations" element={<AdminOrganisationsPage />} />
                              <Route path="organisations/:organisationId" element={<AdminOrganisationDetailPage />} />
                              <Route path="organisations/:organisationId/events" element={<AdminOrganisationEventsPage />} />
                              <Route path="organisations/:organisationId/events/:eventId/galleries" element={<AdminEventGalleriesPage />} />
                              <Route path="users" element={<AdminUsersPage />} />
                              <Route path="events" element={<AdminEventsPage />} />
                              <Route path="events/:eventId" element={<AdminEventDetailPage />} />
                              <Route path="galleries" element={<AdminGalleriesPage />} />
                              <Route path="galleries/:galleryId" element={<AdminGalleryDetailPage />} />
                              <Route path="settings" element={<AdminSettingsPage />} />
                              <Route path="system-settings" element={<AdminSystemSettingsPage />} />
                              <Route path="features" element={<AdminFeaturesPage />} />
                          </Route>
                      </Routes>
                  </AuthProvider>
              </IntlProvider>
          </Provider>
      </ConfigProvider>
  );
}

export default App;